import { View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import { PMProgressBar } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { theme } from "../../../theme";
import { getPluralOfItemName } from "../../../utils/get-plural-of-item-name";

export function addProgressAndBudgetCards(
  view: View<TestAppState, DragAndDropLayout>
): void {
  const progressComponent = view.addComponent({
    component: PMProgressBar,
    layoutProps: {
      componentId: "progressComponent",
      title: "",
      description: "",
      labels: ["progress"],
    },
  });

  progressComponent.mapLayoutProps(({ language }) => ({
    componentId: "progressComponent",
    labels: ["progress"],
    title: getLocalizedMessage(language, "progress"),
    description: getLocalizedMessage(
      language || "en",
      "showsReportingProgress"
    ),
  }));

  progressComponent.mapState(({ dashboard, language, settings }) => {
    const itemName = getPluralOfItemName(
      settings?.configuration?.itemName,
      language
    );
    return {
      label: getLocalizedMessage(language, "progress") || "Progress",
      title: itemName,
      trackColor: "#EEE",
      barColor: theme.palette.primary.contrastText,
      percent: dashboard?._calculated?.averageProgress ?? 0,
    };
  });

  progressComponent.mapVisibility(
    ({ settings }) =>
      settings?.configuration?.fieldsDefinition
        ?.filter((field) => field.purpose === "itemReporting")
        .find((field) => field.fieldName === "progress")?.enabled === true
  );

  const percentageOfBudgetSpentComponent = view.addComponent({
    component: PMProgressBar,
    layoutProps: {
      componentId: "percentageOfBudgetSpentComponent",
      title: "",
      description: "",
      labels: ["budget"],
    },
  });

  percentageOfBudgetSpentComponent.mapLayoutProps(({ language }) => ({
    componentId: "percentageOfBudgetSpentComponent",
    labels: ["budget"],
    title: getLocalizedMessage(language, "metrics.budgetK") || "Budget (k€)",
    description: getLocalizedMessage(language, "showsBudgetSpent"),
  }));

  percentageOfBudgetSpentComponent.mapState(({ dashboard, language }) => {
    const percentageOfBudgetSpent =
      dashboard?._calculated?.percentageOfBudgetSpent ?? 0;
    const spentBudget = dashboard?._calculated?.spentBudget ?? 0;
    const approvedBudget = dashboard?._calculated?.approvedBudget ?? 0;
    const formatKEur = (value: number) =>
      (value / 1000).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
      });

    return {
      label: getLocalizedMessage(language, "spent") || "Spent",
      title: getLocalizedMessage(language, "Budget (k€)") || "BudgetSpent",
      topContent: `${
        getLocalizedMessage(language, "approvedBudget") || "Approved Budget"
      }: ${formatKEur(approvedBudget)}`,
      displayTextOverride: `${formatKEur(spentBudget)} (${Math.round(
        percentageOfBudgetSpent
      )}%)`,
      trackColor: "#E0E0E0",
      barColor: "#38BDF8",
      percent: percentageOfBudgetSpent,
    };
  });

  percentageOfBudgetSpentComponent.mapVisibility(
    ({ settings }) =>
      settings?.configuration?.fieldsDefinition
        ?.filter((field) => field.purpose === "projectBasic")
        .find((field) => field.fieldName === "approvedBudget")?.enabled === true
  );
}
